import React, { useState, useEffect } from 'react';
import { Table } from 'reactstrap';
import { Switch, StoresList } from 'components';
import './table-details.scss';

export function TableDetails({ promise, titles, getStatus }) {

  const [dataTable, setDataTable] = useState("");

  useEffect(() => {
    if(promise.content) {
      promise.content.then((value) => setDataTable(value));
    }
  });

  const renderItem = (item, index, id) => {
    const typesAndAction = {
      switch: () => <Switch id={id} active={item.content} status={getStatus}/>,
      edit: () => <StoresList id={id} />,
      id: () => void (0),
      default: () => item.content
    }

    return typesAndAction[item.type] ?
      typesAndAction[item.type]() :
      typesAndAction['default']();
  }

  const renderData = (data, index, id) => {
    const rows = Object.values(data);
    return rows.map((row, index) => {
      return (
        <td key={index}>
          {renderItem(row, index, id)}
        </td>
      );
    })
  }

  const populateTable = (object) => {
    if (typeof object === "object") {
      return object.map((element, index) => {
        return (
          <tr key={index}>
            {renderData(element, index, element.id.content)}
          </tr>)
      });
    }
  }

  const renderTitles = (titles) => {
    return titles.map(
      (title, index) => <th key={index}> {title}</th>
    )
  }

  return (
    <div className='table-details'>
      <Table striped>
        <thead>
          <tr>
            {renderTitles(titles)}
          </tr>
        </thead>
        <tbody>
          {
            populateTable(dataTable)
          }
        </tbody>
      </Table>
    </div>
  );
}
